<template lang="pug">
.box
    v-server-table(
        :url="url",
        :columns="columns",
        :options="options",
        :name="tableName",
        ref="datatable"
    )
        template(slot="name", slot-scope="props")
            div
                img.w-40.m-r-sm(:src="productImg(props.row)")
                span {{ props.row.name }}

        template(slot="visibility", slot-scope="props")
            i.text-muted(v-if="props.row.pivot.hidden") Hidden
            i(v-else) Visible

        template(slot="pricing", slot-scope="props")
            div(v-if="props.row.price_type == 0")
                .row-col.m-b-sm
                    .row-cell._500.w-pricing.p-r-sm Variant
                    .row-cell._500.w-pricing.p-r-sm Cost
                    .row-cell._500.w-pricing.p-r-sm Price
                    .row-cell._500.w-pricing Visibility
                .row-col.m-b-xs(v-for="variant in props.row.variants", :key="variant.id")
                    .row-cell {{ variant.name }}
                    .row-cell
                        span(:class="{ 'text-l-t text-muted': hasOveriddenVariant(variant, 'cost') }") {{ variant.cost }}
                        span.p-l-sm(v-if="hasOveriddenVariant(variant, 'cost')") {{ variant.variant_entry.cost }}

                    .row-cell
                        span(:class="{ 'text-l-t text-muted': hasOveriddenVariant(variant) }") {{ variant.price }}
                        span.p-l-sm(v-if="hasOveriddenVariant(variant)") {{ variant.variant_entry.price }}
                    .row-cell
                        i.text-muted(v-if="hasOveriddenVariantHidden(variant)") Hidden
                        i(v-else) Visible
            div(v-if="props.row.price_type == 1")
                .row-col
                    .row-cell._500.w-pricing Unit Price
                    .row-cell
                    .row-cell
                    .row-cell
                .row-col
                    .row-cell
                        span(:class="{ 'text-l-t text-muted': hasOveriddenUnitPrice(props.row) }") {{ props.row.unit_price }}
                        span.p-l-sm(v-if="hasOveriddenUnitPrice(props.row)") {{ props.row.pivot.unit_price }}
                    .row-cell
                    .row-cell
                    .row-cell

    add-product(ref="addProduct", @entry-saved="fetchData")
    edit-product(ref="editProduct", @entry-saved="fetchData")
</template>

<script>
import { mapGetters } from 'vuex';
import addProduct from './pricebook-add-product.vue';
import editProduct from './pricebook-edit-product.vue';

export default {
    components: { addProduct, editProduct },

    props: {
        id: {
            type: Number,
            required: true,
        },
        showImport: {
            type: Function,
            required: true,
        },
    },

    data() {
        let actionButtons = [
            {
                title: 'Add Product',
                action: () => {
                    this.$refs.addProduct.$emit('show');
                },
            },
            {
                title: 'Export',
                action: () => {
                    this.exportFile();
                },
            },
            {
                title: 'Import',
                action: () => {
                    this.showImport();
                },
            },
        ];

        return {
            editRowId: null,
            tableName: 'PRICEBOOK_PRODUCTS',
            columns: ['name', 'visibility', 'pricing'],
            options: {
                checkbox: true,
                checkbox_actions: {
                    api_delete: Laroute.route(
                        'franchise.inventory.pricebook.entry.delete',
                        { id: this.id },
                    ),
                    delete_title: 'Remove Products',
                },
                sortable: ['name'],
                texts: {
                    title: 'Products',
                    description: 'Customize product pricing and visibility',
                },
                columnsClasses: {
                    pricing: 'w-lg',
                },
                rowClassCallback: () => 'pointer',
                rowClickCallback: row => {
                    this.$refs.editProduct.$emit('show', row);
                },
                actionButtons: actionButtons,
            },
        };
    },

    computed: {
        ...mapGetters('pricebook', ['pricebook']),

        url() {
            return Laroute.route('franchise.inventory.pricebook.products', {
                id: this.pricebook.id,
            });
        },
    },

    methods: {
        productImg(product) {
            return product.media_urls.length
                ? _.last(product.media_urls).s512
                : '/img/slurp-500.png';
        },

        hasOveriddenVariant(variant, type = 'price') {
            if (
                variant.variant_entry !== null &&
                variant.variant_entry[type] !== null &&
                variant.variant_entry[type] != variant[type]
            )
                return true;

            return false;
        },

        hasOveriddenUnitPrice(product) {
            if (
                product.unit_price !== product.pivot.unit_price &&
                product.pivot.unit_price !== null
            )
                return true;

            return false;
        },

        hasOveriddenVariantHidden(variant) {
            if (
                variant.variant_entry !== null &&
                variant.variant_entry['hidden'] !== null &&
                variant.variant_entry['hidden'] != variant['hidden']
            )
                return variant.variant_entry['hidden'];

            return false;
        },

        fetchData() {
            this.$refs.datatable.getData();
        },

        exportFile() {
            let url = Laroute.route(
                'franchise.inventory.pricebook.exportAsFile',
                {
                    id: this.pricebook.id,
                    type: 'XLSX',
                },
            );

            window.open(`${url}`);
        },
    },
};
</script>

<style lang="scss" scoped>
.w-pricing {
    width: 98px !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/pricebook/pricebook-products.vue